import { render, staticRenderFns } from "./error404.vue?vue&type=template&id=0210349e"
import script from "./error404.vue?vue&type=script&lang=js"
export * from "./error404.vue?vue&type=script&lang=js"
import style0 from "./error404.vue?vue&type=style&index=0&id=0210349e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports